(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["fusion-builder"] && !Shopify.designMode) return;
  try {
    
(function () {
  document.querySelectorAll('[data-fusion-builder]').forEach(function (root) {
    var count = 2;
    var picks = [];
    var pills = root.querySelectorAll('.fb__pill');
    var slots = root.querySelectorAll('.fb__slot');
    var thirds = root.querySelectorAll('.fb__third');
    var scents = root.querySelectorAll('.fb__scent');
    var summary = root.querySelector('[data-fb-summary]');
    var addBtn = root.querySelector('[data-fb-add]');
    var err = root.querySelector('[data-fb-error]');
    var search = root.querySelector('[data-fb-search]');
    var noRes = root.querySelector('[data-fb-noresults]');

    function render() {
      thirds.forEach(function (el) { el.hidden = count < 3; });
      slots.forEach(function (slot, i) {
        var name = picks[i];
        slot.classList.toggle('is-filled', !!name);
        slot.querySelector('.fb__slot-name').textContent = name || 'Kies een geur';
        slot.querySelector('.fb__slot-x').hidden = !name;
      });
      scents.forEach(function (s) {
        var on = picks.indexOf(s.dataset.scent) > -1;
        s.setAttribute('aria-pressed', on ? 'true' : 'false');
        s.disabled = !on && picks.length >= count;
      });
      var pr = root.querySelector('[data-fb-price]');
      if (pr) pr.textContent = (count === 3 ? pr.dataset.p3 : pr.dataset.p2) + ' · 50 ml';
      summary.textContent = picks.length ? picks.join(' + ') + (picks.length < count ? ' + …' : '') : 'Kies ' + count + ' geuren';
      if (picks.length === count) { err.hidden = true; }
    }

    pills.forEach(function (p) {
      p.addEventListener('click', function () {
        count = parseInt(p.dataset.count, 10);
        pills.forEach(function (o) { var on = o === p; o.classList.toggle('is-active', on); o.setAttribute('aria-pressed', on ? 'true' : 'false'); });
        picks = picks.slice(0, count);
        render();
      });
    });

    scents.forEach(function (s) {
      s.addEventListener('click', function () {
        var i = picks.indexOf(s.dataset.scent);
        if (i > -1) { picks.splice(i, 1); }
        else if (picks.length < count) { picks.push(s.dataset.scent); }
        render();
      });
    });

    slots.forEach(function (slot, i) {
      slot.querySelector('.fb__slot-x').addEventListener('click', function () { picks.splice(i, 1); render(); });
    });

    if (search) {
      search.addEventListener('input', function () {
        var q = search.value.trim().toLowerCase();
        var any = false;
        scents.forEach(function (s) {
          var hit = !q || s.dataset.scent.toLowerCase().indexOf(q) > -1;
          s.hidden = !hit;
          if (hit) any = true;
        });
        noRes.hidden = any;
      });
    }

    addBtn.addEventListener('click', function () {
      if (picks.length < count) {
        err.textContent = 'Kies nog ' + (count - picks.length) + (count - picks.length === 1 ? ' geur' : ' geuren') + ' om je mix compleet te maken.';
        err.hidden = false;
        return;
      }
      var props = { 'Mix': picks.join(' + ') };
      picks.forEach(function (n, i) { props['Geur ' + (i + 1)] = n; });
      addBtn.disabled = true;
      addBtn.textContent = 'Bezig…';
      fetch((window.Shopify && Shopify.routes ? Shopify.routes.root : '/') + 'cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify({ items: [{ id: parseInt(count === 3 ? root.dataset.v3 : root.dataset.v2, 10), quantity: 1, properties: props }] })
      }).then(function (r) {
        if (!r.ok) throw new Error();
        if (window.DariCart) {
          addBtn.disabled = false;
          addBtn.textContent = 'Mix in winkelwagen';
          window.DariCart.refresh().then(window.DariCart.open);
        } else {
          window.location.href = (window.Shopify && Shopify.routes ? Shopify.routes.root : '/') + 'cart';
        }
      }).catch(function () {
        addBtn.disabled = false;
        addBtn.textContent = 'Mix in winkelwagen';
        err.textContent = 'Er ging iets mis. Probeer het nog een keer.';
        err.hidden = false;
      });
    });

    render();
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-recommendations"] && !Shopify.designMode) return;
  try {
    
(function () {
  document.querySelectorAll('[data-recs]').forEach(function (el) {
    if (el.querySelector('.grid')) return;
    fetch(el.dataset.url).then(function (r) { return r.text(); }).then(function (html) {
      var doc = new DOMParser().parseFromString(html, 'text/html');
      var fresh = doc.querySelector('[data-recs]');
      if (fresh && fresh.querySelector('.grid')) el.innerHTML = fresh.innerHTML;
    }).catch(function () {});
  });
})();

  } catch(e) { console.error(e); }
})();
})();
